
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/DodaFront/View/MatchJobList",
      function () {
        return require("private-next-pages/DodaFront/View/MatchJobList/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/DodaFront/View/MatchJobList"])
      });
    }
  